import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const LANGUAGE_KEY = "trata_web_language";

const en = {
  common: {
    continue: "Continue",
    sending: "Sending...",
    back: "Back",
  },
  loginUI: {
    patientsOnly: "For Patients Only",
    welcomeHeading: "Welcome",
    loginOrSignup: "Log in or sign up with your mobile number.",
    phoneNumber: "Phone Number",
    enterTenDigitNumber: "Enter 10-digit number",
    keepLoggedIn: "Keep me logged in for 7 days",
    dpdpCompliant: "DPDP Compliant",
    verifyNumberTitle: "Verify your number",
    otpCodeSubtitle: "Enter the 6-digit code sent to +91 {{phone}}.",
    verifyContinue: "Verify & Continue",
    verifying: "Verifying...",
    resendCode: "Resend code",
  },
  emergencyUI: {
    sos: "Emergency SOS",
    callAmbulance: "Need help now? Call an ambulance (108)",
  },
  pinUI: {
    enterPinTitle: "Enter your PIN",
    enterPinSubtitle: "Quick and secure login",
    setPinTitle: "Set up your PIN",
    setPinSubtitle: "Use this PIN to log in faster next time",
    enter4digit: "Enter your 4-digit PIN",
    create4digit: "Create a 4-digit PIN",
    pinHint: "You'll use this to log in quickly next time.",
    enterPin: "Enter PIN",
    confirmPin: "Confirm PIN",
    forgotPin: "Forgot PIN?",
    changeNumber: "Change number",
    pinMismatch: "PINs do not match",
    pin4required: "PIN must be 4 digits",
    setPinButton: "Set PIN & Continue",
    verifying: "Verifying...",
    incorrect: "Incorrect PIN",
    attemptsLeft: "{{count}} attempt(s) left",
    tooManyAttempts: "Too many attempts. Verify with OTP to reset your PIN.",
    enterYourPin: "Enter your 4-digit PIN",
  },
  signupUI: {
    title: "Create your profile",
    subtitle: "Just a few details to get you started.",
    fullNameLabel: "Full name *",
    dobLabel: "Date of birth * (DD/MM/YYYY)",
    genderLabel: "Gender *",
    bloodLabel: "Blood group *",
    cityLabel: "City",
    select: "Select",
    male: "Male",
    female: "Female",
    other: "Other",
    acceptTerms: "I accept the Terms of Service",
    acceptPrivacy: "I accept the Privacy Policy (DPDP)",
    complete: "Complete Sign Up",
    creating: "Creating...",
  },
  languageSelect: {
    tagline: "The Missing Link in Indian Healthcare",
    title: "Select Your Language",
    titleHindi: "अपनी भाषा चुनें",
    english: "English",
    englishNative: "अंग्रेज़ी",
    hindi: "हिंदी",
    hindiNative: "Hindi",
    note: "You can change this later in Settings",
    continueBtn: "Continue",
  },
};

const hi = {
  common: {
    continue: "जारी रखें",
    sending: "भेजा जा रहा है...",
    back: "वापस",
  },
  loginUI: {
    patientsOnly: "केवल मरीज़ों के लिए",
    welcomeHeading: "स्वागत है",
    loginOrSignup: "अपने मोबाइल नंबर से लॉग इन या साइन अप करें।",
    phoneNumber: "मोबाइल नंबर",
    enterTenDigitNumber: "10 अंकों का नंबर डालें",
    keepLoggedIn: "मुझे 7 दिनों तक लॉग इन रखें",
    dpdpCompliant: "DPDP अनुपालन",
    verifyNumberTitle: "अपना नंबर वेरीफाई करें",
    otpCodeSubtitle: "+91 {{phone}} पर भेजा गया 6 अंकों का कोड डालें।",
    verifyContinue: "वेरीफाई करें और जारी रखें",
    verifying: "वेरीफाई हो रहा है...",
    resendCode: "कोड फिर भेजें",
  },
  emergencyUI: {
    sos: "आपातकालीन SOS",
    callAmbulance: "अभी मदद चाहिए? एम्बुलेंस (108) को कॉल करें",
  },
  pinUI: {
    enterPinTitle: "अपना PIN डालें",
    enterPinSubtitle: "तेज़ और सुरक्षित लॉगिन",
    setPinTitle: "अपना PIN सेट करें",
    setPinSubtitle: "अगली बार तेज़ी से लॉगिन करने के लिए इस PIN का उपयोग करें",
    enter4digit: "अपना 4-अंकों का PIN डालें",
    create4digit: "4-अंकों का PIN बनाएँ",
    pinHint: "अगली बार जल्दी लॉगिन करने के लिए इसका उपयोग करें।",
    enterPin: "PIN डालें",
    confirmPin: "PIN की पुष्टि करें",
    forgotPin: "PIN भूल गए?",
    changeNumber: "नंबर बदलें",
    pinMismatch: "PIN मेल नहीं खाते",
    pin4required: "PIN 4 अंकों का होना चाहिए",
    setPinButton: "PIN सेट करें और जारी रखें",
    verifying: "वेरीफाई हो रहा है...",
    incorrect: "गलत PIN",
    attemptsLeft: "{{count}} प्रयास शेष",
    tooManyAttempts: "बहुत अधिक प्रयास। अपना PIN रीसेट करने के लिए OTP से वेरीफाई करें।",
    enterYourPin: "अपना 4-अंकों का PIN डालें",
  },
  signupUI: {
    title: "अपनी प्रोफ़ाइल बनाएँ",
    subtitle: "शुरू करने के लिए बस कुछ जानकारी।",
    fullNameLabel: "पूरा नाम *",
    dobLabel: "जन्म तिथि * (DD/MM/YYYY)",
    genderLabel: "लिंग *",
    bloodLabel: "ब्लड ग्रुप *",
    cityLabel: "शहर",
    select: "चुनें",
    male: "पुरुष",
    female: "महिला",
    other: "अन्य",
    acceptTerms: "मैं सेवा की शर्तें स्वीकार करता/करती हूँ",
    acceptPrivacy: "मैं गोपनीयता नीति (DPDP) स्वीकार करता/करती हूँ",
    complete: "साइन अप पूरा करें",
    creating: "बनाया जा रहा है...",
  },
  languageSelect: {
    tagline: "भारतीय स्वास्थ्य सेवा की कमी पूरी करने वाला",
    title: "अपनी भाषा चुनें",
    titleHindi: "Select Your Language",
    english: "English",
    englishNative: "अंग्रेज़ी",
    hindi: "हिंदी",
    hindiNative: "Hindi",
    note: "आप इसे बाद में सेटिंग्स में बदल सकते हैं",
    continueBtn: "जारी रखें",
  },
};

let initialLang = "en";
try {
  const saved = localStorage.getItem(LANGUAGE_KEY);
  if (saved) initialLang = saved;
} catch (e) {
  // storage unavailable
}

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, hi: { translation: hi } },
  lng: initialLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
